import {Component, OnInit, ViewChild} from '@angular/core';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {MatDialog} from '@angular/material/dialog';
import {ResourceGroupsApiService} from '../../services/api/network/online/resource-group/resource-groups-api.service';
import {MetaDataService} from '../../services/metaData/meta-data.service';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {PageEvent} from '@angular/material/paginator';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {ResourceGroupsDialogComponent} from './resource-groups-dialog/resource-groups-dialog.component';
import * as _ from 'lodash';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {ResourceGroupsSearchComponent} from './resource-groups-search/resource-groups-search.component';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import Search from '../../utils/search';

@Component({
  selector: 'resource-groups',
  templateUrl: './resource-groups.component.html',
  styleUrls: ['./resource-groups.component.scss']
})
export class ResourceGroupsComponent implements OnInit {

  selection: any;
  isUnauthorized: boolean;
  search: any = {};
  nodes: any;
  pCons: any;
  voipPeers: any;
  callsQuotas: any;
  data = {elements: [], totalElements: 0};

  typeOptions = [
    {
      value: 'NODE',
      text: 'Node'
    }, {
      value: 'PEER_CONNECTION',
      text: 'Peer Connection'
    }, {
      value: 'VOIP_PEER',
      text: 'VoIP Peer'
    }
  ];

  isMultipleSelection: false;
  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 200},
    {name: 'displayType', display: 'Type', selected: true, width: 200},
    {name: 'displayElements', display: 'Elements', selected: true, width: 200},
    {name: 'callsQuotaName', display: 'Calls Quota', selected: true, width: 200},
  ];

  @ViewChild(ArmTableComponent) armTable;

  searchData = {};
  searchTerms: SearchTermDefinitionInf[] = [
    {term: 'groupName', operator: ':', displayName: 'Name'},
    {term: 'elementName', operator: ':', displayName: 'Element name'},
    {term: 'type', operator: '=', displayName: 'Type', displayValue: Search.getOptionValue(this.typeOptions)},
  ];

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  resourceSearchComponent = ResourceGroupsSearchComponent;


  constructor(private resourceGroupsService: ResourceGroupsApiService,
              private snackBarService: SnackBarService,
              private userPrivilege: UserPrivilegeService,
              private metaDataService: MetaDataService,
              public dialog: MatDialog,
              private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
    this.setSearchOptions();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  addItem(): void {
    const dialogRef = this.dialog.open(ResourceGroupsDialogComponent, {
      data: {
        isEditMode: false,
        selectedItem: {
          type: 'NODE'
        },
        nodes: this.nodes,
        pCons: this.pCons,
        voipPeers: this.voipPeers,
        callsQuotas: this.callsQuotas,
        elementTypes: this.typeOptions
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.resourceGroupsService.addGroup(result).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.name}" successfully added`);
        this.refresh();
      });
    });
  }

  editItem(): void {
    const selectedItem = _.cloneDeep(this.selection);

    const dialogRef = this.dialog.open(ResourceGroupsDialogComponent, {
      data: {
        isEditMode: true,
        selectedItem,
        nodes: this.nodes,
        pCons: this.pCons,
        voipPeers: this.voipPeers,
        callsQuotas: this.callsQuotas,
        elementTypes: this.typeOptions
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.resourceGroupsService.editGroup(result).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.name}" successfully edited`);
        this.refresh();
      });
    });
  }

  isActionDisabled(): boolean {
    return !this.selection || this.selection.length < 1 || this.isUnauthorized;
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `Are you sure you want to delete "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.resourceGroupsService.deleteGroup(this.selection.id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      });
    });
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    Promise.all([
      this.resourceGroupsService.prepareData(),
      this.resourceGroupsService.getGroups(params)

    ]).then((data) => {
      this.nodes = data[0][0];
      this.pCons = data[0][1];
      this.voipPeers = data[0][2];
      this.callsQuotas = data[0][3].elements;

      this.sortGroupsElementsById(data[1].elements);
      this.addElementsNamesAndDisplayType(data[1], this.nodes, this.pCons, this.voipPeers);
      this.data = data[1];
      this.loaderService.hideMainContainer();
    }).catch(err => {
      console.log(`Exception was thrown in refresh ${err}`);
      this.loaderService.hideMainContainer();
    });
  }


  refreshItems(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.resourceGroupsService.getGroups(params)
      .then(data => {
        this.sortGroupsElementsById(data.elements);
        this.addElementsNamesAndDisplayType(data, this.nodes, this.pCons, this.voipPeers);
        this.data = data;

      }).catch(err => {
      console.log(`Exception was thrown in refreshItems ${err}`);
    });
  }


  sortGroupsElementsById(groups): void {
    groups.forEach(group => group.elements.sort());
  }

  addElementsNamesAndDisplayType(groups, nodes, pCons, voipPeers): void {
    groups.elements.forEach((group) => {
      const elementType = group.type;
      const displayElements = [];
      switch (elementType) {
        case this.metaDataService.ResourceGroupType.NODE.value:
          group.elements.forEach(element => displayElements.push(nodes.find(node => node.id === element).name));
          group.displayType = this.metaDataService.ResourceGroupType.NODE.label;
          break;
        case this.metaDataService.ResourceGroupType.PEER_CONNECTION.value:
          group.elements.forEach(element => displayElements.push(pCons.find(pCon => pCon.id === element).name));
          group.displayType = this.metaDataService.ResourceGroupType.PEER_CONNECTION.label;
          break;
        case this.metaDataService.ResourceGroupType.VOIP_PEER.value:
          group.elements.forEach(element => displayElements.push(voipPeers.find(voipPeer => voipPeer.id === element).name));
          group.displayType = this.metaDataService.ResourceGroupType.VOIP_PEER.label;
          break;
        default:
          break;
      }
      group.displayElements = displayElements.join(', ');
    });
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refreshItems();
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;
    this.refreshItems();
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  private setSearchOptions(): void {
    this.searchData = {
      typeOptions: this.typeOptions
    };
  }
}
